<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Treeselect from '@riophae/vue-treeselect'

	export default {
		props: ['user', 'isAuth', 'agreement'],
		components: {
			'treeselect': Treeselect ,
		},
		data () {
			return {
				modal: {
					selector: 'recurring-create',
				},

				type: null,
				types: [],
				dueDates: [],
				dueDate: null,

				minDatetime: moment().toISOString(),

				item: {
					start: '',
					end: '',
					recurring_doc_id: null,
					due_date: null,
					description: null,
					agreement_id: this.agreement.id,
					auto_send: 1,
				},
			}
		},
		watch: {
			'item.start'() {
				if(!this.item.end) {
					this.item.end = this.item.start
				}
			},
		},
		mounted() {
			var modal = $('#'+this.modal.selector)
			var that = this
			modal.on('hidden.bs.modal', function () {
				that.clearData()
			})
		},
		methods: {
			open() {
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getTypes()
				this.getDueDates()
			},
			clearData() {
				this.item.start = '',
				this.item.end = '',
				this.item.recurring_doc_id = null,
				this.item.description = null,
				this.item.agreement_id = this.agreement.id,
				this.item.auto_send = 1,
				this.dueDate = null,
				this.type = null,
				this.errors.clear()
			},
			getTypes() {
				this.$http.get('admin/recurrings/types')
				.then(response => {
					this.types = response.body
				})
			},
			getDueDates() {
				this.$http.get('admin/management/due/dates')
				.then(response => {
					this.dueDates = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			normalizer(node) {
				var name = node.name
				if(node.lang) {
					var name = node.lang.name
				}
				return {
					id: node.id,
					label: name,
					children: node.children,
				}
			},
			dueDateSelected() {
				if(this.dueDate) {
					this.date = null
					this.item.due_date = this.dueDate.name
				}
			},
			validate(event) {
				event.stopPropagation()
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store () {
				var btnStore = Ladda.create(this.$refs.btnStore)
				btnStore.start()
				this.$http.post('admin/recurrings', this.item)
				.then(response => {
					btnStore.stop()
					this.close()
					this.$emit('reload')
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					btnStore.stop()
					this.$emit('reload')
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/components/recurrings/views/Create.vue